import {MvsCrudService} from "../../../../../../core/shared/service/crud/mvs-crud.service";
import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {MenuItem} from "primeng/api";
import {NsNotificationService} from "../../../../service/api/ns-notification.service";
import {OverviewKpiBaseComponent} from "../../../../../../core/shared/overview/overview-kpi-base.component";
import {KpiHeaderDto} from "../../../../../../core/shared/overview/dto/kpi-header.dto";
import {ObjectRequestListGroupBy} from "../../../../../../core/shared/dto/object/request/object-request-list-group-by";
import {
    ObjectRequestListAttribute
} from "../../../../../../core/shared/dto/object/request/object-request-list-attribute";
import {
    DtoListAttributeRequestAggregateEnum
} from "../../../../../../core/shared/dto/enum/dto-list-attribute-request-aggregate.enum";
import {
    ObjectRequestEntityProcessingTypeEnum
} from "../../../../../../core/shared/dto/object/request/object-request-entity-processing-type.enum";
import {ObjectRequestList} from "../../../../../../core/shared/dto/object/request/object-request-list";


@Component({
    selector: 'mvs-example',
    templateUrl: './notification-kpi.component.html',
    standalone: false
})
export class NotificationKpiComponent extends OverviewKpiBaseComponent implements OnInit, OnChanges, OnDestroy {

    notificationChannelTypeService: MvsCrudService;
    initialized: boolean;

    totalNotifications: number = 0;
    totalNotificationChannel: number = 0;
    thisMonthNotifications: number = 0;
    thisWeekNotifications: number = 0;


    kpiHeaderDto: KpiHeaderDto[];
    items: MenuItem[] | undefined = [{label: 'Notification Module'}];

    constructor(
        protected notificationService: NsNotificationService) {
        super()
    }

    ngOnInit(): void {
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
        this.getTotalNotification();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }


    getTotalNotification() {

        const objectRequestList = ObjectRequestListGroupBy.create(
            false,
            [],
            [],
            ['notificationStatus'],
            [new ObjectRequestListAttribute('notificationStatus', "Anzahl", DtoListAttributeRequestAggregateEnum.count)],
            ObjectRequestEntityProcessingTypeEnum.regular
        );

        this.notificationService.groupBy(objectRequestList).subscribe(res => {
            this.totalNotifications = res.entries.reduce((acc, item) => acc + item['notificationStatus_count'], 0);

            this.getTotalNotificationChannels();
        },error => {
            this.getTotalNotificationChannels();
        });
    }

    getTotalNotificationChannels() {

        const objectRequestList = ObjectRequestList.createBasic(
            false,
            [],
            []);

        this.notificationChannelTypeService.list(objectRequestList).subscribe(res => {
            this.totalNotificationChannel = res.entries.length;
            this.getThisMonthNotifications();
        },error => {
            this.getThisMonthNotifications();
        });
    }

    getThisMonthNotifications() {
        const objectRequestList = this.getThisMonthRequest('notificationStatus');
        this.notificationService.groupBy(objectRequestList).subscribe(res => {
            this.thisMonthNotifications = res.entries.reduce((acc, item) => acc + item['notificationStatus_count'], 0);
            this.getThisWeekLogins();
        }, error => {
            this.getThisWeekLogins();
        });
    }

    getThisWeekLogins() {
        const objectRequestList = this.getThisWeekRequest('notificationStatus');
        this.notificationService.groupBy(objectRequestList).subscribe(res => {
            this.thisWeekNotifications = res.entries.reduce((acc, item) => acc + item['notificationStatus_count'], 0);
            this.initKpiHeaderDto();
        }, error => {
            this.initKpiHeaderDto();
        });
    }

    initKpiHeaderDto() {

        this.kpiHeaderDto = [
            {
                label: 'Total Notifications', value: [this.totalNotifications],
            },
            {
                label: 'Notification Channels', value: [this.totalNotificationChannel],
            },
            {
                label: 'This Month Notifications', value: [this.thisMonthNotifications],
            },
            {
                label: 'This Week Notifications', value: [this.thisWeekNotifications],
            },
        ]
    }


    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
